<div class="container-fluid mt-4 px-3">
  <div class="container-shadow px-3">
    <div *ngIf="loading" class="m-5 p-5 text-center">
      <i class="fas fa-fw fa-spinner fa-5x"></i>
    </div>
    <div *ngIf="!loading">
      <h4 class="py-3">{{ autoTodoRule.id ? 'Editing Auto Todo Rule' : 'New Auto Todo Rule' }}</h4>
      <div class="row">
        <div class="col-md-6">
          <div style="max-width: 40rem">
            <div class="form-group">
              <app-matter-search [matterId]="autoTodoRule.matter_id" (matter_id)="autoTodoRule.matter_id = $event"></app-matter-search>
              <small class="form-text text-muted">Leave matter blank and rule will apply to all matters</small>
            </div>
            <div class="form-group">
              <label>Days After Scan</label>
              <input class="form-control" type="number" min="0" name="days_after" [(ngModel)]="autoTodoRule.days_after" />
            </div>
            <div class="form-group">
              <label>Subject</label>
              <input class="form-control" type="text" name="subject" [(ngModel)]="autoTodoRule.subject" />
            </div>
            <div class="form-group">
              <label>Message</label>
              <textarea class="form-control" name="message" [(ngModel)]="autoTodoRule.message"></textarea>
            </div>
            <div class="form-group">
              <label>Minimum Priority</label>
              <select class="form-control" name="minimum_priority" [(ngModel)]="autoTodoRule.minimum_priority">
                <option *ngFor="let priority of formOptions.priorities" [value]="priority.value">{{ priority.label }}</option>
              </select>
            </div>
            <div class="form-group text-center">
              <button type="button" class="btn btn-primary" (click)="save()" [disabled]="saving">
                {{ saving ? 'Saving' : 'Save' }}<span *ngIf="saving">&nbsp;<i class="fas fa-spinner fa-fw fa-pulse"></i></span>
              </button>
              &nbsp;&nbsp;
              <button type="button" (click)="back()" [disabled]="saving" class="btn btn-outline-secondary">Cancel</button>
            </div>
          </div>
        </div>
        <div class="col-md-6 pt-2">
          <h5 class="pb-3">Select document types</h5>
          <div class="form-group">
            <div class="input-group mb-3">
              <div class="input-group-prepend">
                <span class="input-group-text">Filter by prefix</span>
              </div>
              <input type="text" name="document_type_prefix" [(ngModel)]="documentTypeFilter.prefix" class="form-control" placeholder="Type prefix here" aria-label="Username" (keyup)="nextDocumentTypeTerm()" aria-describedby="basic-addon1" />
            </div>
            <label class="font-weight-bold">Show as&nbsp;</label>
            <div class="custom-control custom-control-inline custom-radio" (click)="documentTypeFilter.showAs = 'list'">
              <input type="radio" name="document_type_list" [checked]="documentTypeFilter.showAs == 'list'" name="customRadio" class="custom-control-input" />
              <label class="custom-control-label">List</label>
            </div>
            <div class="custom-control custom-control-inline custom-radio" (click)="documentTypeFilter.showAs = 'tree'">
              <input type="radio" name="document_type_tree" [checked]="documentTypeFilter.showAs == 'tree'" name="customRadio" class="custom-control-input" />
              <label class="custom-control-label">Tree</label>
            </div>
            <div class="custom-control custom-checkbox" (click)="documentTypeFilter.showOnlySelected = !documentTypeFilter.showOnlySelected">
              <input type="checkbox" [(ngModel)]="documentTypeFilter.showOnlySelected" class="custom-control-input" name="document_type_show_only_selected" />
              <label class="custom-control-label">Show only selected</label>
            </div>
          </div>
          <hr />
          <div *ngIf="documentTypeFilter.showAs == 'list'" class="pl-4">
            <div *ngFor="let documentType of formOptions.document_types">
              <div *ngIf="(!documentTypeFilter.showOnlySelected || documentType.selected) && (!documentTypeFilter.prefix || documentType.searchResult)" class="custom-control custom-checkbox" (click)="documentType.selected = !documentType.selected">
                <input type="checkbox" [(ngModel)]="documentType.selected" class="custom-control-input" name="document_type_selected" />
                <label class="custom-control-label">
                  <span class="font-weight-bold">&nbsp;{{ documentType.prefix }} - </span>
                  <span [ngClass]="{ 'text-muted': !documentType.is_active }">{{ documentType.name }}</span>
                </label>
              </div>
            </div>
          </div>
          <div *ngIf="documentTypeFilter.showAs == 'tree'">
            <ng-container *ngTemplateOutlet="documentTypeListTemplate; context: { documentTypes: formOptions.document_types_tree, firstLevel: true }"> </ng-container>
          </div>
        </div>
      </div>
      <div class="py-3"></div>
    </div>
  </div>
</div>
<ng-template #documentTypeListTemplate let-documentTypesLocal="documentTypes" let-firstLevelLocal="firstLevel">
  <div [ngClass]="{ 'pl-4': !firstLevelLocal }">
    <div [ngClass]="{ 'pl-1': !firstLevelLocal }" *ngFor="let documentType of documentTypesLocal">
      <div *ngIf="!documentTypeFilter.showOnlySelected || documentType.selected || documentType.childSelected">
        <div class="custom-control custom-checkbox" (click)="documentType.selected = !documentType.selected; selectDocumentType(documentType)">
          <input type="checkbox" class="custom-control-input" [(ngModel)]="documentType.selected" />
          <label class="custom-control-label">
            <span class="font-weight-bold">&nbsp;{{ documentType.prefix }} - </span>
            <span [ngClass]="{ 'text-muted': !documentType.is_active }">{{ documentType.name }}</span>
          </label>
        </div>
      </div>
      <div *ngIf="!documentTypeFilter.showOnlySelected || documentType.selected || documentType.childSelected">
        <ng-container *ngTemplateOutlet="documentTypeListTemplate; context: { documentTypes: documentType.children, firstLevel: false }"> </ng-container>
      </div>
    </div>
  </div>
</ng-template>
